import { useState } from "react";
import styled from "styled-components";
import { SecondaryNavigation, SecondaryNavigationMenuItem } from "melco-ui";
import { Dropdown } from "antd";
import { SecondaryNavigationMenu } from "./SecondaryNavigationMenu";
import { useCurrentUser, userInitials } from "melco-shared-logic";
import { BackToAccountsLink } from "./BackToAccountsLink";
import { useCurrentProductVariant } from "../../hooks/useCurrentProductVariant";
import { MELCO_CLOUD } from "../../helper/commonHelper";
import { HelpLink } from "./HelpLink";

const StyledName = styled.div`
  text-transform: uppercase;
`;

export const ControlCenterSecondaryNavigation: React.FC = () => {
  const currentUser = useCurrentUser();
  const [isVisible, setVisible] = useState(false);
  const productVariant = useCurrentProductVariant();

  return (
    <SecondaryNavigation>
      <HelpLink />
      {productVariant == MELCO_CLOUD && <BackToAccountsLink />}
      {currentUser && (
        <Dropdown
          overlay={<SecondaryNavigationMenu setDropDownVisible={setVisible} />}
          trigger={["click"]}
          arrow
          open={isVisible}
          onOpenChange={(v) => setVisible(v)}
        >
          <SecondaryNavigationMenuItem>
            <StyledName>{userInitials(currentUser)}</StyledName>
          </SecondaryNavigationMenuItem>
        </Dropdown>
      )}
    </SecondaryNavigation>
  );
};
